export const NUMBER_OF_HEADSHOTS = 16;
export const ADVS_BY_HEADSHOTS = 2;
export const ADV_BY_SCORERS = 10;
export const LAZY_OFFSET = 3;
export const CARDS_COLOR = '#d6d6d6';
export const ANALYTICS_ELEMENT = 'classifica-marcatori';